import React from "react";
import Link from "next/link";
import * as s from "../index.module.scss";

const DesktopNormaLoansSubMenu = ({ subLinks, setToggle }) => {
  return (
    <div
      className={`${s.sub_links_desktop} ${s.sub_links_desktop_normal} desktop-nav-dropdown`}
    >
      {subLinks.map(({ image, link, title }, idx) => {
        return (
          <Link href={link} key={idx}>
            <p>{title}</p>
          </Link>
        );
      })}
    </div>
  );
};

export default DesktopNormaLoansSubMenu;
